import { useState } from 'react'
import { Upload, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ProjectSectionHeader } from '@/components/projects/ProjectSectionHeader'
import { useAuth } from '@/hooks'
import { Permissions } from '@/lib/permissions'
import { CreateIntentDialog } from './CreateIntentDialog'
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'

interface IntentsHeaderProps {
  projectId: string
  onIntentCreated?: () => void
  onExportCsvClick: () => void
  exportDisabled?: boolean
}

export function IntentsHeader({ projectId, onIntentCreated, onExportCsvClick, exportDisabled }: IntentsHeaderProps) {
  const { hasPermission } = useAuth(projectId)
  const [open, setOpen] = useState(false)

  return (
    <ProjectSectionHeader sectionName="Intents">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="inline-flex">
              <Button
                className="border-border-accent bg-toolbar"
                variant="outline"
                onClick={onExportCsvClick}
                disabled={exportDisabled}
                data-testid="intents-export-all"
              >
                <Upload className="h-4 w-4" />
                Export CSV
              </Button>
            </span>
          </TooltipTrigger>
          {exportDisabled && (
            <TooltipContent>No intents to export</TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
      {hasPermission(Permissions.Project.Intent.Create, projectId) && (
        <Button
          data-testid="new-intent-button"
          onClick={() => setOpen(true)}
        >
          <Plus className="h-4 w-4" />
          New Intent
        </Button>
      )}
      <CreateIntentDialog
        projectId={projectId}
        open={open}
        onOpenChange={setOpen}
        onIntentCreated={onIntentCreated}
      />
    </ProjectSectionHeader>
  )
}
